import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register plugins
gsap.registerPlugin(ScrollTrigger);

// Set defaults for site-wide animations
gsap.defaults({
    ease: 'power2.out',
    duration: 0.8,
});

// Make available globally for easier debugging
if (typeof window !== 'undefined') {
    (window as any).gsap = gsap;
    (window as any).ScrollTrigger = ScrollTrigger;
}

export { gsap, ScrollTrigger };
